$('body').on('mouseover', '.parkinsons-site-nav .parkinsons-site-nav-link', function(){
    var pdn_sub_nav = $(this).closest('.pdn-nav').find('.pdn-sub-nav');
  	if( $(this).hasClass('parkinsons-site-nav--has-dropdown') ){ 
      $(pdn_sub_nav).empty();
      var parkinsons_site_nav_dropdown = $(this).find('.parkinsons-site-nav__dropdown').clone();
      $(pdn_sub_nav).append(parkinsons_site_nav_dropdown);
      $(this).closest('.pdn-nav').addClass('dropDownOpen');
      $(this).find('.parkinsons-site-nav__link').attr('aria-expanded', 'true');
    }else{
      $(pdn_sub_nav).empty();
      $(this).closest('.pdn-nav').removeClass('dropDownOpen');   	
    }
}).on('mouseleave','.pdn-sub-nav', function(){
	$(this).empty();
  	$(this).closest('.pdn-nav').removeClass('dropDownOpen'); 
    $(this).closest('.pdn-nav').find('.parkinsons-site-nav__link').attr('aria-expanded', 'false');
}).on('mouseleave','.pdn-nav', function(){
	$(this).find('.pdn-sub-nav').empty();
  	$(this).removeClass('dropDownOpen'); 
    $(this).find('.parkinsons-site-nav__link').attr('aria-expanded', 'false');  
});

$('body').on('keyup', '.parkinsons-site-nav__link', function( e ){
  e.preventDefault();
  if( e.keyCode == 13 || e.keyCode == 32 ){
    var navEle = $(this).closest('.parkinsons-site-nav-link');
    var pdn_sub_nav = $(navEle).closest('.pdn-nav').find('.pdn-sub-nav');
  	if( $(navEle).hasClass('parkinsons-site-nav--has-dropdown') ){ 
      if( !$(navEle).closest('.pdn-nav').hasClass('dropDownOpen') ){
        $(pdn_sub_nav).empty();
        var parkinsons_site_nav_dropdown = $(navEle).find('.parkinsons-site-nav__dropdown').clone();
        $(pdn_sub_nav).append(parkinsons_site_nav_dropdown);
        $(navEle).closest('.pdn-nav').addClass('dropDownOpen');
        $(this).attr('aria-expanded', 'true');
      }else{
        $(pdn_sub_nav).empty();
        $(navEle).closest('.pdn-nav').removeClass('dropDownOpen');
        $(navEle).closest('.pdn-nav').attr('aria-expanded', 'false');
      }
    }else{
      $(pdn_sub_nav).empty();
      $(navEle).closest('.pdn-nav').removeClass('dropDownOpen');   	
    }    
  }
});


$('body').on('click', '.pac-controller', function(){
	var parkinsons_alt_checkbox = $(this).closest('.parkinsons-alt-checkbox');
      $(parkinsons_alt_checkbox).find('.pac-input').each(function(){
        if( this.checked === true ){
          this.checked = false;
        }  	
      });

  	if( this.checked === true ){
      $(parkinsons_alt_checkbox).find('.positive').each(function(){
        this.checked = true;
      });
    }else{
      $(parkinsons_alt_checkbox).find('.negative').each(function(){
        this.checked = true;
      });
    }
});

$(window).load(function(){
	$('.cart-holder').remove();
});